import { For } from 'solid-js';
import { Portal } from 'solid-js/web';
import { toasts, dismissToast } from './uiState';

export function Toasts() {
  return (
    <Portal>
      <div class="toasts">
        <For each={toasts()}>
          {t => (
            <div class={`toast toast-${t.kind}`} role="status">
              <span class="toast-text">{t.text}</span>
              <button
                type="button"
                class="toast-close"
                aria-label="Close notification"
                onClick={() => dismissToast(t.id)}
              >
                ×
              </button>
            </div>
          )}
        </For>
      </div>
    </Portal>
  );
}
